import { useEffect, useRef } from 'react';
import { preloadImages, isImageCached } from '../utils/imageCache';
import { logger } from '../utils/logger';

interface UseImagePreloaderOptions {
  onLoad?: () => void;
  onError?: (error: Error) => void;
}

export const useImagePreloader = (
  imageUrls: string[],
  options: UseImagePreloaderOptions = {}
) => {
  const { onLoad, onError } = options;
  const isPreloaded = useRef(false);

  useEffect(() => {
    // 이미 프리로드된 경우 스킵
    if (isPreloaded.current) {
      return;
    }

    // 모든 이미지가 이미 캐시되어 있는지 확인
    const allCached = imageUrls.every(url => isImageCached(url));
    
    if (allCached) {
      isPreloaded.current = true;
      onLoad?.();
      return;
    }

    // 이미지 프리로드
    preloadImages(imageUrls)
      .then(() => {
        isPreloaded.current = true;
        onLoad?.();
      })
      .catch((error) => {
        logger.error('Failed to preload images:', error);
        onError?.(error);
      });
  }, [imageUrls, onLoad, onError]);

  return {
    isPreloaded: isPreloaded.current,
  };
}; 